import { combineReducers } from 'redux';

import configuration from './Configuration/ConfigurationReducer';
import consumerLoanSituation from './ConsumerLoanSituation/ConsumerLoanSituationReducer';
import appointmentSituation from './AppointmentSituation/AppointmentSituationReducer'

const appReducer = combineReducers({
    configuration,
    consumerLoanSituation,
    appointmentSituation
});

export default appReducer;
